module.exports = ":host {\n  position: absolute;\n  width: 100%;\n  height: calc(100% - 61px);\n  margin: 0 -15px;\n  transition: all 0.25s linear;\n  -moz-transition: all 0.25s linear;\n  -webkit-transition: all 0.25s linear;\n  -o-transition: all 0.25s linear;\n  opacity: 0;\n  z-index: -1; }\n\n:host.active {\n  background-color: var(--grey-bg);\n  opacity: 1;\n  z-index: 1; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/search/search.component.scss
// module id = ./src/app/modules/search/search.component.scss
// module chunks = main